import { render, staticRenderFns } from "./ModalAgeTechCategory.vue?vue&type=template&id=c04a7ad6"
import script from "./ModalAgeTechCategory.vue?vue&type=script&lang=js"
export * from "./ModalAgeTechCategory.vue?vue&type=script&lang=js"
import style0 from "./ModalAgeTechCategory.vue?vue&type=style&index=0&id=c04a7ad6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports